/**
 * Hook para consultar feature flags do backend.
 * Compartilhado entre componentes e cacheado em window para evitar refetch.
 */
import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
let _cache = null;
let _inflight = null;

export default function useFeatureFlags() {
  const [flags, setFlags] = useState(_cache || {});
  const [loaded, setLoaded] = useState(!!_cache);

  useEffect(() => {
    if (_cache) return;
    if (!_inflight) {
      _inflight = axios.get(`${API}/api/feature-flags`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      }).then(r => {
        _cache = r.data || {};
        return _cache;
      }).catch(() => {
        _cache = {};
        return _cache;
      });
    }
    _inflight.then(c => {
      setFlags(c);
      setLoaded(true);
    });
  }, []);

  return { flags, loaded };
}
